export default __webpack_public_path__ + "static/media/Pgp.35ed8e56.png";